import React, { memo, useState } from "react";
import { Outlet } from "react-router-dom";
import Footer from "../Components/common/Footer";
import NavBar from "../Components/common/NavBar";
import { UserProvider } from "../hooks";
import { ModalProvider } from "../hooks/useModal";
import { CartProvider } from "../hooks/useCard";
import actu from "../assets/img/actu.jpg";
const Root = () => {
  const [isImageVisible, setImageVisible] = useState(true);

  const handleCloseImage = () => {
    setImageVisible(false);
  };

  return (
    <>
      <CartProvider>
        <ModalProvider>
          <UserProvider>
            <NavBar />
          </UserProvider>
          <Outlet />
          <Footer />

          {/* Conditional Image Display */}
          /*{isImageVisible && (
            <div className="image-popup">
              <button className="close-btn" onClick={handleCloseImage}>x</button>
              <img
                src={actu} // Replace with your image URL
                alt="popup"
                className="popup-image"
              />
            </div>
          )}*/
        </ModalProvider>
      </CartProvider>
    </>
  );
};

export default memo(Root);
